<template>
    <div style="margin-top:45px;">
        <h1 align="center">这里是 <span style="color: red;">{{ this.name }}</span> 的样例表</h1>
        <div class="container" style="margin-top: 20px;">
            <div class="row" v-for="(item, index) in example" :key="index">
                <div class="col-1" style="font-size: 16px; font-weight: 600;">输入样例：</div>
                <div class="col-4">
                    <pre>{{ item.inexample }}</pre>
                </div>
                <div class="col-1" style="font-size: 16px; font-weight: 600;">输出样例：</div>
                <div class="col-4">
                    <pre>{{ item.outexample }}</pre>
                </div>
                <div class="col-2">
                    <el-button type="danger" icon="el-icon-delete" circle size="small" @click="Del(item)"></el-button>
                </div>
            </div>
        </div>
        
        <div class="container" style="margin-top: 10px;">
            <div class="row">
                <div class="col text-center">
                    <!-- 添加样例捏 -->
                    <el-button type="info" icon="el-icon-plus" circle @click="isopen = true"></el-button>
                    <el-button type="danger" icon="el-icon-close" circle @click="isopen = false"></el-button>
                </div>
            </div>
        </div>

        <div class="container" v-show="isopen" style="margin-top: 10px;">
            <div class="row">
                <h1 align="center">
                    <span style="color: red;">
                        新增样例
                    </span>
                </h1>
                <div class="col-6">
                    <pre>
                        <el-input
                        type="textarea"
                        :rows="6" 
                        placeholder="inexample"
                        v-model="inexample"
                        clearable>
                        </el-input>
                    </pre>
                </div>
                <div class="col-6">
                    <pre>
                        <el-input
                        type="textarea"
                        :rows="6" 
                        placeholder="outexample"
                        v-model="outexample"
                        clearable>
                        </el-input>
                    </pre>
                </div>
            </div>
            <div class="row">
                <div class="col text-center">
                    <el-button type="success" plain @click="Add">传给后端</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name:'QuestionExample',
        data() {
            return {
                example:[],
                inexample: '',
                outexample: '',
                pbid: '',
                name: '',
                isopen:false,
                error:'',
            }
        },
        mounted() {
            this.pbid = this.$route.query.pbid
            this.name = this.$route.query.name
            console.log("当前题目的pbid == > ", this.pbid, "| 当前题目的名字是 == > ", this.name)
            this.$store.dispatch("problem/SelectExampleList", this.pbid);
            setTimeout(() => {
                this.example = this.$store.state.problem.example
            }, 500);
            // const vue = this
            // const store = this.$store

            // $.ajax({
            //     url: "https://app6132.acapp.acwing.com.cn/api/example/select/",
            //     type: "post",
            //     data: {
            //         pbid: vue.pbid,
            //     },
            //     headers: {
            //         Authorization: "Bearer " + context.rootState.me.token // 这样可以拿到其他模块的数据
            //     },
            //     success(resp) {
            //         const List = JSON.parse(resp.List)
            //         console.log("成功接收样例 resp == >", List)
            //         context.commit("UPDATEEXAMPLE", List)
            //     },
            //     error(resp) {
            //         console.log("未成功接收题库， resp == > ", resp)
            //     }
            // })
        },
        methods: {
            Add() {
                const vue = this
                const store = this.$store
                const message = this.$message
                $.ajax({
                    url:"https://app6132.acapp.acwing.com.cn/api/example/add/",
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        pbid: vue.pbid,
                        inexample: vue.inexample,
                        outexample: vue.outexample,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            message({
                                type: 'success',
                                message: '样例添加成功咯'
                            });
                            store.dispatch("problem/SelectExampleList", vue.pbid)
                            setTimeout(() => { // 立马刷新一下
                                vue.example = store.state.problem.example
                            }, 200);
                        } else {
                            message({
                                type: 'warning',
                                message: '样例添加失败了,原因是 == >' + resp.error_message
                            });
                        }
                    },
                    error(resp) {
                        console.log("样例添加失败啦, resp == > ", resp)
                        message({
                            type: 'warning',
                            message: '添加失败了....'
                        });
                    }
                })
            },
            Del(t) {
                console.log("t", t)
                const vue = this
                const store = this.$store
                const message = this.$message
                $.ajax({
                    url:"https://app6132.acapp.acwing.com.cn/api/example/delete/",
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: t.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            message({
                                type: 'success',
                                message: '样例删除成功咯'
                            });
                            store.dispatch("problem/SelectExampleList", vue.pbid)
                            setTimeout(() => { // 立马刷新一下
                                vue.example = store.state.problem.example
                            }, 200);
                        }
                    },
                    error(resp) {
                        console.log("样例删除失败啦, resp == > ", resp)
                        message({
                            type: 'warning',
                            message: '删除失败了....'
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped>
pre {
    overflow: hidden;
    font-size: 16px;
    min-width: 200px;
    max-width: 800px;
    min-height: 20px;
    height: auto;
    padding-top:2px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
    padding-bottom: 4px;
}
</style>